import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop 組件
 * 在每次路由變化時自動滾動到頁面頂部
 * 提供流暢的用戶體驗
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // 🎯 使用 smooth 滾動行為提供更好的視覺效果
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // 使用 instant 確保立即滾動，避免延遲
    });
  }, [pathname]); // 只在路由改變時觸發

  return null; // 此組件不渲染任何內容
};

export default ScrollToTop;